import React, { useEffect } from 'react';

import PropTypes from "prop-types";

import { useWindowState } from '../../providers/WindowProvider';

const AbstractWindow = ( { id, children, className, style, title } ) => {

    const [ windowState, setWindowState ] = useWindowState();

    useEffect( ()=> {

        let current_windows = windowState.current_windows;

        let this_window = current_windows.find( w => w.id == id );

        if( this_window ){

            this_window.open = true;
        } else {

            this_window = { id, open: true };

            current_windows.push( this_window );
        }

        setWindowState( { ...windowState, current_windows  } );

        return () => {

            let current_windows = windowState.current_windows;

            let this_window = current_windows.find( w => w.id == id );

            if( this_window ){

                this_window.open = false;
            } 

            setWindowState( { ...windowState, current_windows  } );
        }
    },[])

    return(
        <div id={ id } className={`pos-abs tl-0 window no-select cover ${ className }`} style={ style } >
            { children }
            <div className="pos-abs w-100 tr-0 z-1 d-flex text-white align-items-start">
                { title }
            </div>
        </div>
    )
}

AbstractWindow.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.oneOfType( [ PropTypes.object, PropTypes.array ] ),
    className: PropTypes.string,
    style: PropTypes.object,
    title: PropTypes.object
};

export default AbstractWindow;